import {
  ChartBarIcon,
  ShieldCheckIcon,
  RocketLaunchIcon
} from '@heroicons/react/24/outline';
import IntegrationLandingPage from '@/components/integrations/IntegrationLandingPage';
import { getIntegrationsI18nProps } from '@/utils/i18n';
import { useTranslations } from 'next-intl';

export default function ShopifyIntegrationPage() {
  const t = useTranslations('integrations.shopify');
  const stats = [
    { title: t('stats.setupTime.title'), value: t('stats.setupTime.value'), hint: t('stats.setupTime.hint'), icon: RocketLaunchIcon },
    { title: t('stats.tracking.title'), value: t('stats.tracking.value'), hint: t('stats.tracking.hint'), icon: ChartBarIcon },
    { title: t('stats.security.title'), value: t('stats.security.value'), hint: t('stats.security.hint'), icon: ShieldCheckIcon }
  ];
  const features = t.raw('features');
  const steps = t.raw('steps');
  const faqs = t.raw('faqs');

  return (
    <IntegrationLandingPage
      seo={{
        title: t('seo.title'),
        description: t('seo.description'),
        keywords: t('seo.keywords'),
        url: '/shopify-integration'
      }}
      badge={t('badge')}
      title={t('title')}
      subtitle={t('subtitle')}
      primaryCta={{ label: t('cta.primary'), href: 'https://apps.shopify.com/afivio', external: true }}
      secondaryCta={{ label: t('cta.secondary'), href: '/how-it-works' }}
      heroPanel={{
        media: (
          <img
            src="/integration/shopify-integration.webp"
            alt="Shopify and Afivio integration"
            className="h-auto w-full object-contain"
          />
        )
      }}
      stats={stats}
      featuresTitle={t('section.featuresTitle')}
      featuresSubtitle={t('section.featuresSubtitle')}
      features={features}
      stepsTitle={t('section.stepsTitle')}
      stepsSubtitle={t('section.stepsSubtitle')}
      steps={steps}
      experienceTitle={t('section.experienceTitle')}
      experienceDescription={t('section.experienceDescription')}
      experienceBullets={t.raw('section.experienceBullets')}
      faqTitle={t('section.faqTitle')}
      faqSubtitle={t('section.faqSubtitle')}
      faqs={faqs}
      bottomCtaTitle={t('section.bottomCtaTitle')}
      bottomCtaSubtitle={t('section.bottomCtaSubtitle')}
      bottomPrimaryCta={{ label: t('section.bottomPrimaryCta'), href: 'https://apps.shopify.com/afivio' }}
      bottomSecondaryCta={{ label: t('section.bottomSecondaryCta'), href: '/pricing' }}
    />
  );
}

export const getStaticProps = getIntegrationsI18nProps;
